import { observable } from 'mobx';
import { MenuManagementDate } from './types';

export class PlannerLineModel {
  @observable id = '';
  @observable title = '';
  @observable days: MenuManagementDate[] = [];
  @observable deleted?: boolean = false;
}
